/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { Tooltip } from "@material-ui/core";
import React from "react";
import SVG from "react-inlinesvg";
import { NavLink, useLocation } from "react-router-dom";
import { checkIsActive, toAbsoluteUrl } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
	const location = useLocation();
	const getMenuItemActive = (url, hasSubmenu = false) => {
		return checkIsActive(location, url) ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open menu-item-not-hightlighted` : "";
	};

	return (
		<>
			{/* begin::Menu Nav */}
			<ul className={`menu-nav ${layoutProps.ulClasses}`}>
				{/*begin::1 Level*/}
				<li className={`menu-item ${getMenuItemActive("/dashboard", false)}`} aria-haspopup="true">
					<NavLink className="menu-link" to={"/dashboard"}>
						<span className="svg-icon menu-icon">
							<Tooltip title="Dashboard">
								<SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
							</Tooltip>
						</span>
						<span className="menu-text">Dashboard</span>
					</NavLink>
				</li>

				{/* new masterUser with subMenu start*/}
				<li className={`menu-item ${getMenuItemActive("/master-user", true)}`} aria-haspopup="true" >
					<NavLink className="menu-link  " to={"/master-user/list"}>
						<span className="svg-icon menu-icon">
							<Tooltip title="Master Users">
								<SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Shield-user.svg")} />
							</Tooltip>
						</span>
						<span className="menu-text">Master Users</span>
					</NavLink>
				</li>

				<li className={`menu-item ${getMenuItemActive("/subordinate-user", false)}`} aria-haspopup="true">
					<NavLink className="menu-link" to={"/subordinate-user"}>
						<span className="svg-icon menu-icon">
							<Tooltip title="Subordinate Users">
								<SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
							</Tooltip>
						</span>
						<span className="menu-text">Subordinate Users</span>
					</NavLink>
				</li>

				<li className={`menu-item ${getMenuItemActive("/room-types", false)}`} aria-haspopup="true">
					<NavLink className="menu-link" to={"/room-types"}>
						<span className="svg-icon menu-icon">
							<Tooltip title="Room Types">
								<SVG src={toAbsoluteUrl("/media/svg/icons/Home/Door-open.svg")} />
							</Tooltip>
						</span>
						<span className="menu-text">Room Types</span>
					</NavLink>
				</li>

				<li className={`menu-item menu-item-submenu ${getMenuItemActive("/devices",
					true)}`}
					aria-haspopup="true"
					data-menu-toggle="hover">
					<NavLink className="menu-link" to={"/devices"}>
						<span className="svg-icon menu-icon">
							<Tooltip title="Devices">
								<SVG src={toAbsoluteUrl("/media/svg/icons/Devices/CPU1.svg")} />
							</Tooltip>
						</span>
						<span className="menu-text">Devices</span>
					</NavLink>
				</li>

				<li className={`menu-item menu-item-submenu ${getMenuItemActive("/device-appliances",
					true)}`}
					aria-haspopup="true"
					data-menu-toggle="hover">
					<NavLink className="menu-link" to={"/device-appliances"}>
						<span className="svg-icon menu-icon">
							<Tooltip title="Devices">
								<SVG src={toAbsoluteUrl("/media/svg/icons/Home/Chair1.svg")} />
							</Tooltip>
						</span>
						<span className="menu-text">Device Appliances</span>
					</NavLink>
				</li>

				<li className={`menu-item ${getMenuItemActive("/icons", false)}`} aria-haspopup="true">
					<NavLink className="menu-link" to={"/icons"}>
						<span className="svg-icon menu-icon">
							<Tooltip title="Icons">
								<SVG src={toAbsoluteUrl("/media/svg/icons/General/Star.svg")} />
							</Tooltip>
						</span>
						<span className="menu-text">Icons</span>
					</NavLink>
				</li>

				<li className={`menu-item ${getMenuItemActive("/faq", false)}`} aria-haspopup="true">
					<NavLink className="menu-link" to={"/faq"}>
						<span className="svg-icon menu-icon">
							<Tooltip title="FAQ">
								<SVG src={toAbsoluteUrl("/media/svg/icons/General/Clipboard.svg")} />
							</Tooltip>
						</span>
						<span className="menu-text">FAQ</span>
					</NavLink>
				</li>

				<li className={`menu-item ${getMenuItemActive("/default-settings", false)}`} aria-haspopup="true">
					<NavLink className="menu-link" to={"/default-settings"}>
						<span className="svg-icon menu-icon">
							<Tooltip title="Default Settings">
								<SVG src={toAbsoluteUrl("/media/svg/icons/General/Settings-1.svg")} />
							</Tooltip>
						</span>
						<span className="menu-text">Default Settings</span>
					</NavLink>
				</li>

				<li className={`menu-item  ${getMenuItemActive("/firmware-file", false)}`} aria-haspopup="true">
					<NavLink className="menu-link" to={"/firmware-file"}>
						<span className="svg-icon menu-icon">
							<Tooltip title="Firmware Files">
								<SVG src={toAbsoluteUrl("/media/svg/icons/Files/Uploaded-file.svg")} />
							</Tooltip>
						</span>
						<span className="menu-text">Firmware Files</span>
					</NavLink>
				</li>


				<li className="menu-section ">
					{/* <h4 className="menu-text">Custom</h4> */}
					<i className="menu-icon flaticon-more-v2"></i>
				</li>
				{/* end:: section */}
				{/* Error Pages */}
			</ul>
			{/* end::Menu Nav */}
		</>
	);
}
